import * as React from 'react';
import {useTranslation} from 'react-i18next';

import {addMinutes, format} from 'date-fns';
import {SalesEventsType} from './SalesEventsAgendaView';
import * as styles from './salesEvents.module.scss';
import {parseDate} from '@src/utils';

interface SalesEventsDateViewProps {
  salesEvents: SalesEventsType[];
}

const SalesEventsDateView: React.FC<SalesEventsDateViewProps> = props => {
  const {t} = useTranslation('SalesEvents');

  const salesEvents = props.salesEvents.sort((a, b) =>
    a.start_time.localeCompare(b.start_time!),
  );

  const eventTimes = (salesEvent: SalesEventsType) => {
    const startTime = parseDate(salesEvent.zoneless_start_time_at);
    const eventStartTime = format(startTime, 'h:mm aaa');

    const endDatetime = addMinutes(startTime, salesEvent.duration_minutes);
    const eventEndTime = format(endDatetime, 'h:mm aaa');
    return `${eventStartTime} – ${eventEndTime} (${salesEvent.time_zone})`;
  };

  return (
    <div>
      <ul>
        {salesEvents.map(salesEvent => {
          const salesEventVenue = salesEvent.sales_event_venue;
          const presentationLanguage =
            salesEvent.language === 'English' ||
            salesEvent.language === 'Spanish'
              ? salesEvent.language
              : 'English';
          return (
            <li key={salesEvent.id}>
              <div className="wrapper">
                <div className={styles.eventRow}>
                  <div className={styles.leftColumn}>
                    <strong>{t('whenLabel')}</strong>
                  </div>
                  <div>{eventTimes(salesEvent)}</div>
                </div>
                <div className={styles.eventRow}>
                  <div className={styles.leftColumn}>
                    <strong>{t('whereLabel')}</strong>
                  </div>
                  <div>
                    {salesEventVenue.name}
                    <br />
                    {salesEventVenue.address1}
                    <br />
                    {salesEventVenue.address2 && (
                      <>
                        {salesEventVenue.address2}
                        <br />
                      </>
                    )}
                    {salesEventVenue.city}, {salesEventVenue.state}{' '}
                    {salesEventVenue.zip}
                  </div>
                </div>
                <div className={styles.eventRow}>
                  <div className={styles.leftColumn}>
                    <strong>{t('countyLabel')}</strong>
                  </div>
                  <div>{salesEventVenue.county_name}</div>
                </div>
                <div className={styles.eventRow}>
                  <div className={styles.leftColumn}>
                    <strong>{t('recordLocatorLabel')}</strong>{' '}
                    {salesEvent.record_locator}
                  </div>
                </div>
                <div className={styles.eventRow}>
                  <div className={styles.leftColumn}>
                    <i>
                      {t('presentationLanguageText', {
                        language: t(presentationLanguage),
                      })}
                    </i>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SalesEventsDateView;
